import React, { FC, useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation, useParams } from "react-router";
import { BackArrow, Button, ModalVariables, Tabs, TopProgress, Typography } from "../../../../components";
import { usePageTitle } from "../../../../context/navigationContext";
import {
  Container,
  InstanceName,
  NavWrapper,
  RightHeadContainer,
  HeadWrapper
} from './styles'
import {
  Overview,
  Clients,
  UserGroups,
  PermissionsPage,
  ActivityLog,
  AuditLog,
  // ApiAccessPage
} from './components'
import { clientService } from "../../../../api";
import { useUi } from "../../../../context/ui.context";
import MenuButton from "../../../../components/button/menu-button";
import DropOptions from "../../../../components/header/components/drop-options";
import { PropsContainer } from "../../../../components/table/styles";
import { icons } from "../../../../icons";
import { Cookies, useCookies } from 'react-cookie';

const UserPage:FC = () => {
  const navigate = useNavigate()
  const [t] = useTranslation()
  const {viewAlert} = useUi()
  const {userId} = useParams()
  const [activeTab, setActiveTab] = useState<string>('1')
  const location = useLocation()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [user, setUser] = useState<any>()
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any[]>([])
  const [options, setOptions] = useState(false)
  const optionsRef:any = useRef(null)
  const dropsRef:any = useRef(null)
  const [cookies, setCookie, removeCookie] = useCookies([]);
  usePageTitle(user ? `${t("PAGE_TITLE_USER_DETAIL")}: ${user?.full_name || user?.email || userId}` : t("PAGE_TITLE_USER_DETAIL"))

  const getData = async () => {
    if(!userId) return
    try{
      const res = await clientService.getUsersById(userId)
      setUser(res.data)
      setPageLoading(false)
    }catch(e:any){
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail || t("ERROR_OCCURED"),
      })
    }
  }
  useEffect(() => {
    getData()
  },[])

  const getUserDisplayName = () => {
    return user?.full_name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.email || userId
  }
  const openDeleteModal = () => {
    setModalType('delete')
    setAlertTitle(t("USER"))
    setAlertSubTitle([{...user, name: getUserDisplayName()}])
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const closeModal = async () => {
    if (!userId || modalType !== 'delete') return
    setDeleteLoading(true)
    try{
      await clientService.deleteUser(userId)
      viewAlert({
        severity:'success',
        message:t("USER_DELETED_SUCCESSFULLY")
      })
      navigate('/clients-users/users')
    } catch(e:any){
      if(e?.response?.data?.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail
        })
      }
    } finally {
      setDeleteLoading(false)
      closeModalCancel()
    }
  }

  useEffect(() => {
    const lastPathSegment = location.pathname.split('/').pop();
    tabs.forEach((item) => {
      if (lastPathSegment === item.slug) {
        setActiveTab(item.slug);
      }
    });
  }, [location]);
  const [tabs, setTabs] = useState<any[]>( [
    {
      title:t("OVERVIEW"),
      slug:'overview',
      id:'1'
    },
    {
      title:t("CLIENTS"),
      slug:'clients',
      id:'2'
    },
    {
      title:t("USER_GROUPS"),
      slug:'user-groups',
      id:'3'
    },
    {
      title:t("PERMISSIONS"),
      slug:'permissions',
      id:'4'
    },
    {
      title:t("ACTIVITY_LOG"),
      slug:'activity-log',
      id:'5'
    },
    {
      title:t("AUDIT_LOG"),
      slug:'audit-log',
      id:'6'
    },
  ])
const itemsDefault = [
    {
      title:t("EDIT"),
      id:'1',
      onClick:() => {
        navigate(`/clients-users/users/${userId}/edit`)
      },
      icon:icons.Edit,
      divider:false
    },
    {
      title:t("IMPERSONATE"),
      id:'2',
      onClick:async() => {
        if(!userId) return
        const {data} = await clientService.impersonateUser(userId)
        console.log('data', data);
        //@ts-ignore
        // data?.cookies.forEach(({ name, value, options }) => {
        //   //@ts-ignore
        //   setCookie(name, value, options);
        // });
        if(!data?.cookies) return
        //@ts-ignore
        Object.entries(data?.cookies).forEach(([name, cookie]:any) => {
          console.log('name',name);
          const options = {
            domain: cookie.domain,
            path: cookie.path,
            secure: cookie.secure,
            expires: cookie.expires ? new Date(cookie.expires * 1000) : undefined,
            // Note: Other attributes like discard, rfc2109, version, port, comment, etc., are not supported by react-cookie
          };
          console.log('options',options);

          //@ts-ignore
          // setCookie(name, cookie?.value, options);
        });
        // Redirect to the specified URL
        // window.open('https://auth.netengi.ua/auth/realms/sendbox/protocol/openid-connect/auth?client_id=frontend_main&redirect_uri=https%3A%2F%2Fportal.10support.com%2F&state=40d49047-6abb-41a2-8566-975634a7f2e2&response_mode=fragment&response_type=code&scope=openid&nonce=43fad739-3b4f-440d-b7ac-51febadce3bc');
        // window.open('https://portal.10support.com');
        // openModal('rescue-instance',{
        //   alertTitle:user.name,
        //   closeModal:() => {}
        // })
      },
      icon:icons.SupportGrey,
      divider:false
    },
    {
      title:t("DELETE"),
      id:'3',
      icon:icons.DeleteIcon,
      onClick:() => {
        openDeleteModal()
      },
      divider:false
    },
   
  ]
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <BackArrow fallbackPath="/clients-users/users" fallbackTitle={t("USERS")}/>
      <HeadWrapper>
        <div>
          <InstanceName>
            {t("ACCOUNT_SETTINGS")}
          </InstanceName>
          <Typography variant='body-medium'>
            {user?.full_name || `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.email}
          </Typography>
        </div>
        <RightHeadContainer> 
          <div ref={dropsRef}>
            <Button
              variant="stroke"
              isFill
              size='small'
              icon={icons.More}
              test_id='menu_button'
              title={t("MENU")}
              onClick={() => setOptions(!options)}
            />
          </div>
          <PropsContainer style={{top:'35px', right:'0px'}} ref={optionsRef} active={options}>
            <DropOptions
              handleClose={() => setOptions(false)}
              options={itemsDefault}
            />
          </PropsContainer>
        </RightHeadContainer>
      </HeadWrapper>
      <NavWrapper>
        <Tabs
          tabs={tabs}
          size='display'
          blockNavigate
          location={activeTab}
          onChange={(e) => {
            navigate(`/clients-users/users/${userId}/${e}`)
          }}
        />
      </NavWrapper>
      <Routes>
        <Route index element={<Navigate replace to="overview" />} /> 
        <Route path='overview' element={<Overview user={user}/>}/>
        <Route path='clients' element={<Clients />}/>
        <Route path='user-groups' element={<UserGroups userGroups={user.user_groups} />}/>
        <Route path='permissions' element={<PermissionsPage  />}/>
        <Route path='activity-log' element={<ActivityLog user={user}/>}/>
        <Route path='audit-log' element={<AuditLog user={user}/>}/>
        
      </Routes>
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={deleteLoading}
      />

    </Container>
  )
}

export default UserPage
